import { render, staticRenderFns } from "./memberStyle.vue?vue&type=template&id=20217c00&scoped=true&"
import script from "./memberStyle.vue?vue&type=script&lang=js&"
export * from "./memberStyle.vue?vue&type=script&lang=js&"
import style0 from "./memberStyle.vue?vue&type=style&index=0&id=20217c00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20217c00",
  null
  
)

export default component.exports